var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cluster_truck_path",
    d: "M172.51 1181c-.28 0-.51.232-.51.515v7.206c0 .282.23.514.51.514h1.24c0 .975.784 1.765 1.75 1.765s1.75-.79 1.75-1.765h1.823c.28 0 .51-.232.51-.514v-7.206a.515.515 0 0 0-.51-.515h-6.563zm8.04 1.176a.385.385 0 0 0-.383.387v6.286c0 .159.1.292.237.35a.39.39 0 0 0 .145.036h.784c0 .975.784 1.765 1.75 1.765s1.75-.79 1.75-1.765h.784c.053 0 .1-.016.146-.036a.377.377 0 0 0 .2-.203.359.359 0 0 0 .037-.147v-3.033a.37.37 0 0 0-.073-.202l-2.151-3.272a.365.365 0 0 0-.31-.166h-2.917zm1.367 1.177h1.476l1.55 2.353h-3.026v-2.353zm-6.417 5c.483 0 .875.395.875.882a.879.879 0 0 1-.875.883.879.879 0 0 1-.875-.883c0-.487.392-.882.875-.882zm7.583 0c.483 0 .875.395.875.882a.879.879 0 0 1-.875.883.879.879 0 0 1-.875-.883c0-.487.392-.882.875-.882z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "cluster_truck_filter",
    width: "150%",
    height: "170%",
    x: "-25%",
    y: "-25%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(-170 -1180)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cluster_truck_filter)",
    xlinkHref: "#cluster_truck_path"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cluster_truck_path"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckImage);
export default __webpack_public_path__ + "static/media/truckImage.5442eed838781386eb784187c6a41b9e.svg";
export { ForwardRef as ReactComponent };